import { useMutation } from '@tanstack/react-query'
import { createCarePlan } from '../services/care_plan';

const AddCarePlan = () => {
 const addCarePlan = useMutation({
    queryKey:['create_care_plan'],
    mutationFn: createCarePlan
 })
 return addCarePlan;
}

export default AddCarePlan